import {PIXI} from '@colonist/pixi'
import {SelectCardPopupStealCardFromAnotherPlayerFormat} from '@colonist/game-card-types'
import {UIGameManager} from '../UIGameManager'
import {UIGamePopupSelectCards} from './UIGamePopupSelectCards'
import {UIGamePopupCondensedCardInformationController} from './UIGamePopupCondensedCardInformationController'
import {CardEnum} from '@colonist/game-states'

export class UIGamePopupSelectDevelopmentCardFromPlayer extends UIGamePopupSelectCards {
    private readonly condensedCardInformationController: UIGamePopupCondensedCardInformationController

    constructor(uiGameManager: UIGameManager, popupImageAndDescription: PIXI.Container, selectCardFormat: SelectCardPopupStealCardFromAnotherPlayerFormat) {
        const buildContainer = false
        super(uiGameManager, popupImageAndDescription, selectCardFormat.selectCardFormat, buildContainer)

        const parentContainer = this.selectCardContainer.cardsSelected
        const padding = this.uiGameManager.canvasController.itemSize * 0.3
        const textX = padding + this.selectCardContainer.cardsToSelectFrom.cardW
        const textW = this.width - textX - (this.width - this.confirmationButtons.checkButton.x) - padding
        const textY = parentContainer.y + this.selectCardContainer.y
        this.condensedCardInformationController = new UIGamePopupCondensedCardInformationController(this.uiGameManager, this, textX, textY, textW, this.selectCardFormat.validCardsToSelect)

        this.addVictimAvatarView(selectCardFormat.victim)

        const horizontalBuffer = 0
        const longestTextHeight = this.condensedCardInformationController.getLongestTextHeight(this.selectCardFormat.validCardsToSelect)
        const verticalBuffer = longestTextHeight < this.selectCardContainer.cardsSelected.height ? 0 : longestTextHeight - this.selectCardContainer.cardsSelected.height

        this.buildContainer(horizontalBuffer, verticalBuffer)
    }

    protected clickedTopResource(cardEnum: CardEnum) {
        this.resetSelection()
        const animate = false
        super.clickedTopResource(cardEnum, animate)
        this.condensedCardInformationController.showSelectedCardInformation(cardEnum)
    }

    private resetSelection() {
        if(!this.selectedEnoughCards()) return
        this.selectCardContainer.cardsSelected.removeAllCards()
    }

    protected clickedSelectedResource(cardEnum: CardEnum) {
        super.clickedSelectedResource(cardEnum)
        this.condensedCardInformationController.removeSelectedCardInformation()
    }
}
